import React from "react"

import { useLayerPopupContext } from "@shared/contexts"

function Alert() {
  const { alert, close } = useLayerPopupContext()

  return (
    <React.Fragment>
      <article className="popup">
        <div className="titB">
          <h1>확인</h1>
          <a
            href="#!"
            title="닫기"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            닫기
          </a>
        </div>
        <div className="txtB">
          <div
            className="roundB"
            style={{ whiteSpace: "pre-wrap" }}
            dangerouslySetInnerHTML={{ __html: alert.contents }}
          ></div>
        </div>
        <div className="btnB">
          <a
            href="#!"
            title="확인"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            확인
          </a>
        </div>
      </article>
    </React.Fragment>
  )
}

export default Alert
